module.exports = __webpack_public_path__ + "static/media/unapprove_icon.9a344a26.svg";